module.exports = __webpack_public_path__ + "img/marcopolo.2decfdd9.jpg";